var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('StyledSelect',{staticClass:"langSelect",attrs:{"options":_vm.options,"data-linktracking":"top-nav:language"},scopedSlots:_vm._u([{key:"selected",fn:function(ref){
var value = ref.value;
return [_vm._v(_vm._s(value.toUpperCase()))]}}]),model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})}
var staticRenderFns = []

export { render, staticRenderFns }